export default "__VITE_ASSET__CzvDatjN__"